import React, { Component, useState } from "react";

import { Row, Col, Divider, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { API_URL } from "../../../../constants";
import useAxios from "@use-hooks/axios";
import moment from "jalali-moment";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

//JS Files
import BooksInsideCard from "./BooksInsideCard";
import BooksInsideSummary from "./BooksInsideSummary";
import BooksInsideSimilar from "./BooksInsideSimilar";

const BooksInside = (props) => {
  const [book, setBook] = useState([]);
  const [books, setBooks] = useState([]);

  const getBook = useAxios({
    url: `${API_URL}/Book_Service/${props.id}`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("data", res.data);
        setBook(res.data);
      }
    },
  });

  const getBooks = useAxios({
    url: `${API_URL}/Book_Service/`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("books data", res.data);

        setBooks(res.data);
      }
    },
  });

  return props.size === "laptopdesktop" ? (
    <div className="BooksInsideBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>
              کتاب، مقالات و پایان نامه ها
            </strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={4}></Col>
        <Col span={16}>
          {getBook.response?.data && (
            <BooksInsideCard book={book} size="laptopdesktop" />
          )}
        </Col>
        <Col span={4}></Col>
      </Row>
      <Margin top={4}></Margin>
      {getBook.response?.data && (
        <BooksInsideSummary book={book} size="laptopdesktop" />
      )}
      
      {getBooks.response?.data && (
        <BooksInsideSimilar
          history={props.history}
          books={books.filter((item) => item.id != props.id).slice(0, 5)}
          size="laptopdesktop"
        />
      )}
    </div>
  ) : props.size === "tablet" ? (
      <div className="BooksInsideBackground">
        <div style={{ paddingTop: "75px" }}>
          <Center>
            <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
              <strong>
                کتاب، مقالات و پایان نامه ها
            </strong>
            </p>
          </Center>
        </div>
        <Row style={{ marginTop: "75px" }}>
          <Col span={2}></Col>
          <Col span={20}>
            {getBook.response?.data && (
              <BooksInsideCard book={book} size="tablet" />
            )}
          </Col>
          <Col span={2}></Col>
        </Row>
        <Margin top={4}></Margin>
        {getBook.response?.data && (
          <BooksInsideSummary book={book} size="tablet" />
        )}
        {getBooks.response?.data && (
          <BooksInsideSimilar
            history={props.history}
            books={books.filter((item) => item.id != props.id).slice(0, 3)}
            size="tablet"
          />
        )}
      </div>
  ) : (
        <div className="BooksInsideBackground">
          <div style={{ paddingTop: "75px" }}>
            <Center>
              <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
                <strong>
                  کتاب، مقالات و پایان نامه ها
            </strong>
              </p>
            </Center>
          </div>
          <Row style={{ marginTop: "50px" }}>
            <Col span={1}></Col>
            <Col span={22}>
              {getBook.response?.data && (
                <BooksInsideCard book={book} />
              )}
            </Col>
            <Col span={1}></Col>
          </Row>
          <Margin top={4}></Margin>
          {getBook.response?.data && (
            <BooksInsideSummary book={book} />
          )}
          {getBooks.response?.data && (
            <BooksInsideSimilar
              history={props.history}
              books={books.filter((item) => item.id != props.id).slice(0, 4)}
            />
          )}
        </div>
  );
};

export default BooksInside;
